<template>
  <button
    ref="addToComparison"
    class="add-to-comparison"
    :class="{ 'add-to-comparison--added': isAdded, 'is-product-page': productPage }"
    @click="handleClick"
    :title="isAdded ? this.$t('in.comparison') : this.$t('to.comparison')"
  >
    <div class="add-to-comparison__wrap">
      <span class="add-to-comparison__svg-wrap">
        <svg width="25" height="25" class="add-to-comparison__svg">
          <use :xlink:href="spritePath + '#comparison'"></use>
        </svg>
        <svg
          v-if="isAdded"
          class="add-to-comparison__checkmark"
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="6.5"
                  cy="6.5"
                  r="6"
                  fill="#52D04F"
                  stroke="white" />
          <rect x="2.6001"
                y="6.65743"
                width="1.3"
                height="3.9"
                transform="rotate(-45 2.6001 6.65743)"
                fill="white" />
          <rect x="9.03467"
                y="3.90001"
                width="1.3"
                height="6.5"
                transform="rotate(45 9.03467 3.90001)"
                fill="white" />
        </svg>
      </span>
      <!--      <span class="add-to-comparison__text">-->
      <!--        {{ isAdded ? this.$t('in.comparison') : this.$t('to.comparison') }}-->
      <!--      </span>-->
    </div>
  </button>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { spritePath } from '../../../mixins/spritePath'
import { GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  name: 'AddToComparisonBtn',
  mixins: [spritePath],
  data () {
    return {
      isProductPage: false
    }
  },
  props: {
    productId: [Number, String],
    titleRu: String,
    productPage: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.isProductPage = this.$refs.addToComparison.parentNode.classList.contains('product-description__comparison')
  },
  computed: {
    ...mapState({
      comparisonInfoHeader: state => state.productComparison.comparisonInfoHeader
    }),
    ...mapGetters(['productsToComparison']),
    isAdded () {
      if (this.productSetId) return true

      let currentId = this.productId.toString()
      let productSetId = ''
      if (this.isProductSet) {
        productSetId = this.productId.split('&')[0].split('=')[1]
        currentId = `${productSetId}:${this.productId.split('=')[2]}`
      }
      let isAdded = false

      for (let i = 0; i < this.productsToComparison.length; i++) {
        if (this.productsToComparison[i] === currentId) {
          isAdded = true
          break
        }
      }
      return isAdded
    },
    isProductSet () {
      return typeof this.productId === 'string'
    },
    productSetId () {
      let productSetId = ''
      for (let i = 0; i < this.productsToComparison.length; i++) {
        const id = this.productsToComparison[i]
        if (id.includes(':') && id.split(':')[0] === this.productId.toString()) {
          productSetId = id
          break
        }
      }
      return productSetId
    },
    productInSetId () {
      if (typeof this.productId === 'string') {
        const splitedId = this.productId.split('=')
        return splitedId[1].split('&')[0] + ':' + splitedId[2]
      } else {
        return ''
      }
    }
  },
  methods: {
    ...mapActions([
      'ADD_TO_COMPARISON_ACTION',
      'FETCH_COMPARISON_INFO_HEADER',
      'SET_WHICH_TO_COMPARE_MODAL_INFO_ACTION',
      'REMOVE_PRODUCT_FROM_COMPARISON'
    ]),
    handleClick () {
      if (!this.isAdded || this.productSetId) {
        let url = '/comparison/add/?id=' + this.productId
        if (typeof this.productId === 'string') {
          if (this.productId.includes('uk/')) {
            url = this.productId.replace('uk/', '')
          } else {
            url = this.productId
          }
        }
        this.ADD_TO_COMPARISON_ACTION(url).then(response => {
          if (response.code === 1) {
            this.SET_WHICH_TO_COMPARE_MODAL_INFO_ACTION(response.data)
            this.$modal.show('which-to-compare')
          } else if (response.code === 2 && !this.isAdded) {
            this.ADD_TO_COMPARISON_ACTION(response.data[0].add_url).then(res => {
              if (res.status === 'success') {
                this.notifySuccess(this.$t('success_add_to_comparison'))
                GoogleTagManagerService.pushToDatalayer({
                  'event': 'add_to_compare',
                  'eventCategory': 'Compare',
                  'eventAction': 'Add',
                  'eventLabel': this.titleRu
                })
              }
            })
          } else if (response.code === 2 && this.isAdded) {
            const setId = response.data[0].add_url.split('?')[1]
            this.REMOVE_PRODUCT_FROM_COMPARISON({ productId: '', url: '/comparison/remove/?' + setId }).then(res => {
              if (res.status === 'success') {
                this.notifySuccess(this.$t('success_remove_from_comparison'))
                GoogleTagManagerService.pushToDatalayer({
                  'event': 'remove_from_compare',
                  'eventCategory': 'Compare',
                  'eventAction': 'Remove',
                  'eventLabel': this.titleRu
                })
              }
            })
          } else if (response.status === 'success') {
            this.notifySuccess(this.$t('success_add_to_comparison'))
            GoogleTagManagerService.pushToDatalayer({
              'event': 'add_to_compare',
              'eventCategory': 'Compare',
              'eventAction': 'Add',
              'eventLabel': this.titleRu
            })
          }
        })
      } else if (this.isAdded || (this.isAdded && this.productInSetId)) {
        let url = `?id=${this.productId}`
        if (this.productInSetId) {
          const ids = this.productInSetId.split(':')
          url = `?id=${ids[0]}&set_product_id=${ids[1]}`
        }
        const data = {
          productId: this.productSetId || this.productId,
          url: `/comparison/remove/${url}`
        }

        this.REMOVE_PRODUCT_FROM_COMPARISON(data).then(res => {
          if (res.status === 'success') {
            this.notifySuccess(this.$t('success_remove_from_comparison'))
            GoogleTagManagerService.pushToDatalayer({
              'event': 'remove_from_compare',
              'eventCategory': 'Compare',
              'eventAction': 'Remove',
              'eventLabel': this.titleRu
            })
          }
        })
      }
    },
    notifySuccess (message) {
      this.$notify({
        group: 'success',
        title: '',
        text: message,
        type: 'success'
      })
    }
  }
}
</script>

<style scoped lang="sass">

.add-to-comparison
  padding: 0
  background: transparent
  border: 0
  fill: #909090

  &:hover
    .add-to-comparison__svg
      fill: #ff2f00

.add-to-comparison__svg-wrap
  position: relative

.add-to-comparison--added
  .add-to-comparison__svg
    fill: $text-color

.add-to-comparison__svg
  margin-top: -1px
  vertical-align: middle

.add-to-comparison__checkmark
  position: absolute
  bottom: -5px
  right: -4px

.add-to-comparison__text
  display: block
  margin-top: 9px
  color: $placeholder-color
  font-weight: 400
  font-size: 11px
  line-height: 13px
  min-width: 70px

.product-card__add-to-comparison
  display: flex
  align-items: center
  fill: $text-color

  +mmin($tablet)
    display: none
    padding: 5px
    background-color: #F8F8F8
    border-radius: 3px

    &:hover
      background-color: #E7E7E7

  &:hover .add-to-comparison__svg
    fill: $text-color

.product-card .product-card__add-to-comparison.add-to-comparison--added
  +mmin($tablet)
    display: block

.product-card__add-to-comparison .add-to-comparison__text
  min-width: auto
  font-size: 12px
  line-height: 14px
  color: $placeholder-color
  stroke: #cccccc
  margin-top: 0
  margin-left: 10px

  +mmin($tablet)
    display: none

.product-card__add-to-comparison .add-to-comparison__wrap
  flex-direction: row

.product-card--not--adaptive
  .product-card__add-to-comparison
    padding: 5px
    background-color: #F8F8F8
    border-radius: 3px

    &:hover
      background-color: #E7E7E7

  .add-to-comparison__text
    display: none

.add-to-comparison__wrap
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center

.is-product-page
  width: 48%
  background-color: #F8F8F8
  height: 46px
  margin-right: 15px

  .add-to-comparison__wrap
    flex-direction: row

  .add-to-comparison__text
    display: block
    font-size: 14px
    color: $text-color
    margin: 0 0 0 10px

.product-actions__btn--comparison
  +mmax(768)
    height: 50px

  +mmin($tablet)
    display: flex
    justify-content: center
    align-items: center
    width: auto
    background-color: transparent
    //padding: 0 10px

  .add-to-comparison__text
    +mmin($tablet--hor)
      display: none

    +mmin(1360)
      display: block

  .add-to-comparison__svg-wrap
    +mmin($tablet)
      display: flex
      justify-content: center
      align-items: center
      padding: 11px 10.5px
      background-color: #f8f8f8
      border-radius: 3px

  .add-to-comparison__checkmark
    +mmin($tablet)
      bottom: 5px
      right: 5px
.product-card__info
  .add-to-comparison__svg
    width: 18px
    height: 18px
</style>
